<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header" style="padding: 0">
        <el-collapse v-model="activeCollapse" @change="handleCollapse">
          <el-collapse-item name="1">
            <template slot="title">{{ titleFilter }}</template>

            <div class="row m-1 mb-1">
              <div class="col-md-3">
                <label>{{ $t('consolidatedSummary.business') }}:</label>
                <br />
                <el-select
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  class="select-primary w-100 mb-3 shadow-sm required-businesses"
                  :placeholder="`${$t('common_words.select2')}...`"
                  v-model="filters.businesses"
                  @change="
                    selectAllFromSelect(
                      'filters.businesses',
                      catalogs.businesses
                    );
                    onBusinessChange();
                  "
                >
                  <el-option
                    v-for="item in catalogs.businesses"
                    class="select-primary selected-all"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>

              <div class="col-md-3">
                <label>{{ $t('consolidatedSummary.farm') }}:</label>
                <br />
                <el-select
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  class="select-primary w-100 mb-3 shadow-sm required-farms"
                  :placeholder="`${$t('common_words.select2')}...`"
                  v-model="filters.farms"
                  :disabled="
                    !filters.businesses || filters.businesses.length === 0
                  "
                  @change="
                    selectAllFromSelect('filters.farms', filteredFarms);
                    onFarmChange();
                  "
                >
                  <el-option
                    v-for="item in filteredFarms"
                    class="select-primary selected-all"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>

              <div class="col-md-3">
                <label>{{ $t('audit.audit') }}:</label>
                <br />
                <el-select
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  class="select-primary w-100 mb-3 shadow-sm required-audits"
                  :placeholder="`${$t('common_words.select2')}...`"
                  v-model="filters.audits"
                  :disabled="!filters.farms || filters.farms.length === 0"
                  @change="
                    selectAllFromSelect('filters.audits', filteredAudits);
                    onAuditChange();
                  "
                >
                  <el-option
                    v-for="item in filteredAudits"
                    class="select-primary selected-all"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>

              <div class="col-md-3">
                <label>{{ $t('consolidatedSummary.variable') }}:</label>
                <br />
                <el-select
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  class="select-primary w-100 mb-3 shadow-sm required-tasks"
                  :placeholder="`${$t('common_words.select2')}...`"
                  v-model="filters.tasks"
                  :disabled="!filters.audits || filters.audits.length === 0"
                  @change="selectAllFromSelect('filters.tasks', filteredTasks)"
                >
                  <el-option
                    v-for="item in filteredTasks"
                    class="select-primary selected-all"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>

            <div class="row m-1">
              <div class="col-md-auto">
                <label>{{ $t('common_words.analyze_by') }}</label>
                <br />
                <el-select
                  @change="changeByInterval()"
                  filterable
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="payload.frecuency"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in Object.values(optionsInterval)"
                    class="select-primary"
                    :value="option.id"
                    :label="option.label"
                    :key="option.id"
                  />
                </el-select>
              </div>

              <div
                class="col-md-auto"
                v-if="
                  payload.frecuency !== 'weekly' &&
                  payload.frecuency !== 'annually'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderDatePicker"
                  v-model="payload.rangeDate"
                  class="shadow-sm mb-3"
                  v-bind:type="typedatepicket"
                  range-separator="-"
                  :clearable="false"
                  :picker-options="pickerOptions"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                />
              </div>

              <div
                class="col-md-auto"
                v-if="
                  payload.frecuency === 'weekly' ||
                  payload.frecuency === 'annually'
                "
              >
                <label>{{ $t('common_words.initial_year') }}:</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="payload.year_sel_init"
                >
                  <el-option
                    v-for="(opt, idx) in Object.keys(listYears).reverse()"
                    class="select-primary"
                    :value="opt"
                    :label="opt"
                    :key="idx"
                  />
                </el-select>
              </div>

              <div class="col-md-auto" v-if="payload.frecuency === 'weekly'">
                <label>{{ $t('common_words.initial_week') }}:</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-week shadow-sm"
                  size="large"
                  v-model="payload.week_sel_init"
                >
                  <el-option
                    v-for="(week, idx) in listYears[payload.year_sel_init]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="idx"
                  />
                </el-select>
              </div>

              <div
                class="col-md-auto"
                v-if="
                  payload.frecuency === 'weekly' ||
                  payload.frecuency === 'annually'
                "
              >
                <label>{{ $t('common_words.end_year') }}:</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="payload.year_sel_end"
                >
                  <el-option
                    v-for="(opt, idx) in Object.keys(listYears).reverse()"
                    class="select-primary"
                    :value="opt"
                    :label="opt"
                    :key="idx"
                  />
                </el-select>
              </div>

              <div class="col-md-auto" v-if="payload.frecuency === 'weekly'">
                <label>{{ $t('common_words.end_week2') }}:</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-week shadow-sm"
                  size="large"
                  v-model="payload.week_sel_end"
                >
                  <el-option
                    v-for="(week, idx) in listYears[payload.year_sel_end]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="idx"
                  />
                </el-select>
              </div>

              <div class="col text-left col-btn-filter pl-0">
                <label style="color: transparent">{{
                  $t('common_words.filter')
                }}</label>
                <br />
                <l-button
                  class="shadow-sm btn-filter"
                  wide
                  type="success"
                  @click="generateReport()"
                  >{{ $t('common_words.filter') }}</l-button
                >
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>

    <div
      class="col-12"
      v-if="
        reportData.consolidated &&
        reportData.consolidated.rows &&
        reportData.consolidated.rows.length > 0
      "
    >
      <card class="custom-shadow-card-header" style="padding: 0">
        <div>
          <div v-if="queriedData.length > 0" class="mt-5 px-3 pb-3">
            <div class="row mb-3 mt-4 justify-content-end">
              <select-component
                :dataOptions="[
                  { id: 'line', name: 'Líneas' },
                  { id: 'column', name: 'Columnas' },
                ]"
                :isMultiple="false"
                labelSelect="Tipo de Gráfica:"
                modelName="chartType"
                :initialSelection="chartType"
                @onChange="handleChangeChartType"
                rowClass="col-12 col-md-4 col-lg-3 pr-md-4"
              />
            </div>
            <div class="row">
              <div class="col-12">
                <highcharts
                  :options="chartOptions"
                  style="width: 100%"
                ></highcharts>
              </div>
            </div>
            <hr />
          </div>

          <el-tabs v-model="activeTab" @tab-click="handleTabClick">
            <el-tab-pane name="consolidated">
              <span slot="label"
                ><i class="fa fa-chart-bar mr-1"></i> Consolidado</span
              >
            </el-tab-pane>
            <el-tab-pane
              v-for="(farmData, farmName) in reportData.farms"
              :name="farmName"
              :key="farmName"
            >
              <span slot="label"
                ><i class="fa fa-map-marker-alt mr-1"></i> {{ farmName }}</span
              >
            </el-tab-pane>
          </el-tabs>

          <card-header
            ref="cardHeader"
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-3"
          ></card-header>

          <el-table
            :data="queriedData"
            border
            stripe
            :header-cell-style="{ background: '#006535', color: '#ffffff' }"
            style="width: 100%"
            show-summary
            :summary-method="getSummaries"
          >
            <el-table-column
              prop="date"
              :label="$t('common_words.date')"
              width="150"
              align="center"
              fixed="left"
            ></el-table-column>

            <el-table-column
              v-for="col in reportData.columns"
              :key="col.id"
              :prop="'task_' + col.id"
              :label="col.name"
              align="center"
              min-width="150"
            >
              <template slot-scope="scope">
                {{ formatNumber(scope.row['task_' + col.id]) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="total_general"
              :label="$t('common_words.total')"
              align="center"
              width="150"
              fixed="right"
            >
              <template slot-scope="scope">
                <strong>{{ formatNumber(scope.row.total_general) }}</strong>
              </template>
            </el-table-column>
          </el-table>

          <div
            class="my-3 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>

          <hr class="my-3" />

          <div class="d-flex justify-content-center mt-3 mb-4">
            <button
              class="btn btn-danger custom-shadow-btn mx-2"
              @click="exportPDF"
            >
              <em class="fa fa-file-pdf-o"></em> Exportar a PDF
            </button>
            <button
              class="btn custom-btn-success custom-shadow-btn mx-2"
              @click="exportExcel"
            >
              <em class="fa fa-file-excel-o"></em> Exportar a Excel
            </button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import swal from 'sweetalert2';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinFilter from 'src/util/mixinFilter';
import mixinMasters from 'src/util/mixinMasters';
import mixinLoading from 'src/mixins/mixin-loading';
import { Chart } from 'highcharts-vue';
import SelectComponent from 'src/components/Selects/Select.vue';

export default {
  name: 'AuditIndicatorReport',
  components: {
    highcharts: Chart,
    SelectComponent,
  },
  mixins: [MixinDatePicker, mixinFilter, mixinLoading, mixinMasters],
  data() {
    return {
      tabStates: {},
      chartType: 'line',
      activeTab: 'consolidated',
      activeCollapse: ['1'],
      loading: false,
      loadingExcel: false,
      loadingPdf: false,
      searched: false,
      dates: [
        moment().subtract(30, 'days').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      filters: {
        frecuency: 'daily',
        businesses: [],
        farms: [],
        audits: [],
        tasks: [],
      },
      catalogs: {
        businesses: [],
        farms: [],
        audits: [],
        tasks: [],
      },
      payload: {
        businesses: [],
        stations: [],
        zones: [],
        subzones: [],
        farms: [],
        rangeDate: null,
        frecuency: 'daily',
        year_sel_init: null,
        year_sel_end: null,
        week_sel_init: 1,
        week_sel_end: 1,
      },
      listYears: {},
      reportData: {
        columns: [],
        consolidated: { rows: [], totals: [] },
        farms: {},
      },
      renderDatePicker: true,
      typedatepicket: 'daterange',
    };
  },
  watch: {
    activeTab(newTab, oldTab) {
      if (oldTab) {
        this.tabStates[oldTab] = {
          searchQuery: this.searchQuery,
          pagination: { ...this.pagination },
        };
      }

      if (this.tabStates[newTab]) {
        this.searchQuery = this.tabStates[newTab].searchQuery;
        this.pagination = { ...this.tabStates[newTab].pagination };
      } else {
        this.searchQuery = '';
        this.pagination.currentPage = 1;
      }

      this.$nextTick(() => {
        if (this.$refs.cardHeader) {
          this.$refs.cardHeader.searchQuery = this.searchQuery;
        }
      });
    },
  },
  computed: {
    /**
     * Opciones disponibles para la frecuencia de análisis.
     */
    optionsInterval() {
      return {
        1: {
          id: 'daily',
          label: this.$t('common_words.day'),
          value: 'daterange',
        },
        2: { id: 'weekly', label: this.$t('common_words.week'), value: 'week' },
        3: {
          id: 'monthly',
          label: this.$t('common_words.month'),
          value: 'monthrange',
        },
        4: {
          id: 'annually',
          label: this.$t('common_words.year'),
          value: 'year',
        },
      };
    },
    /**
     * Filtra las fincas en base a las empresas seleccionadas (cascada).
     */
    filteredFarms() {
      const realBus = (this.filters.businesses || [])
        .filter((id) => Number(id) !== 0)
        .map(Number);
      if (realBus.length === 0) return this.catalogs.farms;

      return this.catalogs.farms.filter(
        (f) =>
          f.id === 0 ||
          (f.business_ids &&
            f.business_ids.some((b) => realBus.includes(Number(b))))
      );
    },
    /**
     * Filtra las auditorías en base a las fincas seleccionadas (cascada).
     */
    filteredAudits() {
      const realFarms = (this.filters.farms || [])
        .filter((id) => Number(id) !== 0)
        .map(Number);
      if (realFarms.length === 0) return this.catalogs.audits;
      return this.catalogs.audits.filter(
        (a) =>
          a.id === 0 ||
          (a.farm_ids &&
            a.farm_ids.some((fId) => realFarms.includes(Number(fId))))
      );
    },
    /**
     * Filtra las variables (tareas) en base a las auditorías seleccionadas (cascada).
     */
    filteredTasks() {
      const realAudits = (this.filters.audits || [])
        .filter((id) => Number(id) !== 0)
        .map(Number);
      if (realAudits.length === 0) return this.catalogs.tasks;

      return this.catalogs.tasks.filter(
        (f) => f.id === 0 || realAudits.includes(Number(f.audit_id))
      );
    },
    /**
     * Obtiene el set de datos correspondiente al tab activo (consolidado o por finca).
     */
    currentReportSet() {
      if (!this.reportData) return null;
      if (this.activeTab === 'consolidated' && this.reportData.consolidated) {
        return this.reportData.consolidated;
      } else if (
        this.reportData.farms &&
        this.reportData.farms[this.activeTab]
      ) {
        return this.reportData.farms[this.activeTab];
      }
      return { rows: [], totals: [] };
    },
    /**
     * Configuración dinámica para Highcharts basada en los datos actuales del tab.
     */
    chartOptions() {
      if (
        !this.currentReportSet ||
        !this.currentReportSet.rows ||
        this.currentReportSet.rows.length === 0
      ) {
        return {};
      }

      const rows = this.currentReportSet.rows;
      const columns = this.reportData.columns || [];
      const categories = rows.map((row) => row.date);

      const series = columns.map((col) => {
        const key = `task_${col.id}`;
        return {
          name: col.name,
          data: rows.map((row) => {
            const val = row[key];
            return val !== null && val !== undefined ? parseFloat(val) : null;
          }),
        };
      });

      return {
        chart: {
          type: this.chartType,
          zoomType: 'x',
        },
        title: {
          text: `<b>${
            this.activeTab === 'consolidated' ? 'Consolidado' : this.activeTab
          }</b>`,
        },
        xAxis: {
          categories: categories,
          title: {
            text: '<b>Fechas</b>',
          },
          labels: {
            rotation: -45,
            style: { fontSize: '10px' },
          },
        },
        yAxis: {
          title: {
            text: '<b>Porcentaje (%)</b>',
          },
          labels: {
            format: '{value} %',
          },
        },
        tooltip: {
          valueSuffix: ' %',
          shared: true,
        },
        credits: {
          enabled: false,
        },
        series: series,
      };
    },
    /**
     * Datos filtrados de la tabla basados en la búsqueda global y paginación.
     */
    queriedData() {
      const reportSet = this.currentReportSet;
      let result = reportSet && reportSet.rows ? reportSet.rows : [];
      if (this.searchQuery && this.searchQuery.trim() !== '') {
        const q = this.searchQuery.trim().toLowerCase().replace(',', '.');
        result = result.filter((row) =>
          Object.values(row).some((val) =>
            String(val === null || val === undefined ? '' : val)
              .toLowerCase()
              .replace(',', '.')
              .includes(q)
          )
        );
      }
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
  },
  mounted() {
    this.getFilters();
  },
  methods: {
    /**
     * Actualiza el tipo de gráfica seleccionado.
     * @param {Object} data - Objeto con la información de la selección.
     */
    handleChangeChartType(data) {
      if (data && data.name === 'chartType') {
        this.chartType = data.selects;
      }
    },
    /**
     * Helper para descargar un archivo Blob generado por el servidor.
     * @param {Blob} data - Datos del archivo en crudo.
     * @param {string} filename - Nombre del archivo a descargar.
     */
    downloadFile(data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    /**
     * Genera los totales para la fila final de sumario de la tabla.
     * @param {Object} param - Objeto provisto por Element UI con columnas y datos.
     * @returns {Array} Arreglo con los valores calculados de sumario.
     */
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      const totals = this.currentReportSet ? this.currentReportSet.totals : {};

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Total General';
          return;
        }
        const val = totals[column.property];
        sums[index] = val !== undefined ? this.formatNumber(val) : '0,00';
      });

      return sums;
    },
    /**
     * Maneja el evento de clic en los tabs (Consolidado o por Fincas).
     */
    handleTabClick() {

    },
    /**
     * Formatea numéricamente un valor.
     * @param {number|string} val - Valor a formatear.
     * @returns {string}
     */
    formatNumber(val) {
      if (val === null || val === undefined) return '0.0';
      return val.toString();
    },
    /**
     * Obtiene los catálogos y filtros iniciales para llenar los selectores (empresas, fincas, etc.).
     */
    async getFilters() {
      this.showHideLoading(true);
      try {
        const [resFilters, resYears] = await Promise.all([
          this.$axios.get('auth/advanced/audits/indicatorreport/filters'),
          this.$axios.get('auth/climates/weatherstationreport/getselectinfo'),
        ]);
        this.catalogs = resFilters.data.data || resFilters.data;

        if (resYears && resYears.data) {
          this.listYears = resYears.data.listYears || {};
          const years = Object.keys(this.listYears).reverse();
          if (years.length) {
            this.payload.year_sel_init = years[0];
            this.payload.year_sel_end = years[0];
          }
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.payload.rangeDate = [today, today];

        if (this.catalogs.businesses)
          this.catalogs.businesses = this.concatAll(this.catalogs.businesses);
        if (this.catalogs.farms)
          this.catalogs.farms = this.concatAll(this.catalogs.farms);
        if (this.catalogs.audits)
          this.catalogs.audits = this.concatAll(this.catalogs.audits);
        if (this.catalogs.tasks)
          this.catalogs.tasks = this.concatAll(this.catalogs.tasks);
      } catch (error) {
        console.error(error);
        SweetAlert.danger(this.$t('common_words.error'));
      } finally {
        this.showHideLoading();
      }
    },
    /**
     * Reacciona al cambio de selección de empresas, limpiando y actualizando dependientes.
     */
    onBusinessChange() {
      this.searched = false;
      if (this.filters.businesses && this.filters.businesses.length > 0) {
        const validFarms = new Set(this.filteredFarms.map((f) => f.id));
        this.filters.farms = this.filters.farms.filter((fId) =>
          validFarms.has(fId)
        );
      } else {
        this.filters.farms = [];
      }
      this.onFarmChange();
    },
    /**
     * Reacciona al cambio de selección de fincas, limpiando y actualizando dependientes.
     */
    onFarmChange() {
      this.searched = false;

      if (this.filters.farms && this.filters.farms.length > 0) {
        const validAuditIds = new Set(this.filteredAudits.map((a) => a.id));
        this.filters.audits = (this.filters.audits || []).filter((aId) =>
          validAuditIds.has(aId)
        );
      } else {
        this.filters.audits = [];
      }
      this.onAuditChange();
    },
    /**
     * Reacciona al cambio de selección de auditorías, limpiando y actualizando tareas.
     */
    onAuditChange() {
      this.searched = false;
      if (this.filters.audits && this.filters.audits.length > 0) {
        const validTasks = new Set(this.filteredTasks.map((t) => t.id));
        this.filters.tasks = this.filters.tasks.filter((tId) =>
          validTasks.has(tId)
        );
      } else {
        this.filters.tasks = [];
      }
    },
    /**
     * Ajusta el formato de selección de fecha (rango, mes, año) dependiendo del intervalo elegido.
     */
    changeByInterval() {
      this.payload.rangeDate = null;
      const option = Object.values(this.optionsInterval).find(
        (o) => o.id === this.payload.frecuency
      );
      this.typedatepicket = option ? option.value : 'daterange';
      this.renderDatePicker = false;
      this.$nextTick(() => {
        this.renderDatePicker = true;
      });
    },
    /**
     * Validates the selected filters and fetches the report data from the backend.
     * @returns {Promise<void>}
     */
    async generateReport() {
      const isValid = await this.validationInputsRequired(
        'businesses',
        false,
        false,
        true
      );
      if (!isValid) return;

      const isValidFarms = await this.validationInputsRequired(
        'farms',
        false,
        false,
        true
      );
      if (!isValidFarms) return;

      const isValidAudits = await this.validationInputsRequired(
        'audits',
        false,
        false,
        true
      );
      if (!isValidAudits) return;

      const isValidTasks = await this.validationInputsRequired(
        'tasks',
        false,
        false,
        true
      );
      if (!isValidTasks) return;

      const needsRange =
        this.payload.frecuency !== 'weekly' &&
        this.payload.frecuency !== 'annually';
      if (
        needsRange &&
        (!this.payload.rangeDate || this.payload.rangeDate.length !== 2)
      ) {
        SweetAlert.warning(this.$t('common_words.select_date'));
        return;
      }

      if (
        (this.payload.frecuency === 'weekly' ||
          this.payload.frecuency === 'annually') &&
        (!this.payload.year_sel_init || !this.payload.year_sel_end)
      ) {
        SweetAlert.warning(this.$t('common_words.select_date'));
        return;
      }

      this.showHideLoading(true);
      this.searched = false;
      this.tabStates = {};
      this.searchQuery = '';
      if (this.$refs.cardHeader) {
        this.$refs.cardHeader.searchQuery = '';
      }
      this.reportData = {
        columns: [],
        consolidated: { rows: [], totals: [] },
        farms: {},
      };

      this.$axios
        .post('auth/advanced/audits/indicatorreport/generate', {
          filters: this.filters,
          payload: this.payload,
        })
        .then((response) => {
          this.reportData = response.data.data;
          this.activeTab = 'consolidated';
          this.pagination.currentPage = 1;
          this.pagination.total =
            this.reportData.consolidated && this.reportData.consolidated.rows
              ? this.reportData.consolidated.rows.length
              : 0;
          this.searched = true;
          if (
            this.reportData &&
            this.reportData.consolidated &&
            (!this.reportData.consolidated.rows ||
              this.reportData.consolidated.rows.length === 0)
          ) {
            SweetAlert.warning(this.$t('common_words.unavailable_data'));
          }
        })
        .catch((error) => {
          console.error(error);
          SweetAlert.danger(this.$t('common_words.error'));
        })
        .finally(() => {
          this.showHideLoading();
        });
    },
    /**
     * Exports the current report data to an Excel file.
     */
    exportExcel() {
      this.loadingExcel = true;
      SweetAlert.download(
        this.$t('mix.mixin_export.wait_while_excel_downloads'),
        swal
      );
      this.$axios
        .post(
          'auth/advanced/audits/indicatorreport/excel',
          {
            filters: this.filters,
            payload: this.payload,
            activeTab: this.activeTab,
          },
          { responseType: 'blob' }
        )
        .then((response) => {
          this.downloadFile(response.data, 'Indicador_de_Auditorias.xlsx');
        })
        .finally(() => {
          this.loadingExcel = false;
          swal.close();
        });
    },
    /**
     * Exports the current report data to a PDF file.
     */
    exportPDF() {
      this.loadingPdf = true;
      SweetAlert.download(
        this.$t('mix.mixin_export.wait_while_pdf_downloads'),
        swal
      );
      this.$axios
        .post(
          'auth/advanced/audits/indicatorreport/pdf',
          {
            filters: this.filters,
            payload: this.payload,
            activeTab: this.activeTab,
          },
          { responseType: 'blob' }
        )
        .then((response) => {
          this.downloadFile(response.data, 'Indicador_de_Auditorias.pdf');
        })
        .finally(() => {
          this.loadingPdf = false;
          swal.close();
        });
    },
  },
};
</script>

<style scoped>
::v-deep .el-tabs__item {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.3s;
}
::v-deep .el-tabs__item:hover {
  color: #679768;
}
::v-deep .el-tabs__item.is-active {
  color: #679768 !important;
}
::v-deep .el-tabs__active-bar {
  background-color: #679768 !important;
  height: 3px;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: #e4e4e4;
  height: 2px;
}
::v-deep .el-table__footer-wrapper tbody td,
::v-deep .el-table__fixed-footer-wrapper tbody td {
  background-color: #888 !important;
  border-top: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  text-align: center !important;
  padding: 12px 0;
}
::v-deep .el-table th {
  background-color: #888 !important;
  color: #ffffff !important;
}
::v-deep .el-table__footer-wrapper tbody td .cell,
::v-deep .el-table__fixed-footer-wrapper tbody td .cell {
  color: #ffffff !important;
  font-weight: bold !important;
  font-size: 14px !important;
}
</style>
